import React from 'react';
import PropTypes from 'prop-types';
import SMFormFieldTitle from 'components/dashboard/form/SMFormFieldTitle';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMFormTextFieldWithError from 'components/dashboard/form/SMFormTextFieldWithError';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMFormHelper from 'components/helpers/SMFormHelper';
import SMFormRadio from 'components/dashboard/form/SMFormRadio';
import SMFormRadioWithError from 'components/dashboard/form/SMFormRadioWithError';
import SMConst from 'lib/SMConst';
import SMRoomHelper from 'components/helpers/SMRoomHelper';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';
import SMFormTextAreaWithError from 'components/dashboard/form/SMFormTextAreaWithError';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMFormCheckBox from 'components/dashboard/form/SMFormCheckBox';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import update from 'react-addons-update';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';


class SMOPlanEditView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      model: this.props.model,
      errors: this.props.errors
    };
  }

  componentWillMount() {
    let rentType = this.state.model.rent_type;
    let allowRentTypes = this.props.room.allow_rent_types;
    if (Array.isArray(allowRentTypes) && allowRentTypes.indexOf(rentType) == -1) {
      this.setState({
        model: {
          rent_type: allowRentTypes[0]
        }
      });
    }
  }

  componentDidMount(){
    $(document).on("SMRoomDidUpdateSuccess", this.roomDidUpdateSuccess.bind(this));
    $(document).on("SMRoomDidFailToUpdate", this.roomDidFailToUpdate.bind(this));
  }

  componentWillUnmount() {
    $(document).off("SMRoomDidUpdateSuccess", this.roomDidUpdateSuccess);
    $(document).off("SMRoomDidFailToUpdate", this.roomDidFailToUpdate);
  }

  roomDidUpdateSuccess(e, name, value, room){
    let model;
    if (this.isBasicPlan()) {
      model = room;
    } else {
      model = room.plans[this.props.planIndex];
    }

    this.setState({
      model: model,
      room: room,
      errors: []
    });
  }

  roomDidFailToUpdate(e, name, value, errors){
    this.setState({
      errors: errors
    });
  }

  isBasicPlan() {
    return this.props.planIndex == -1;
  }

  hasStayPrice(nextModel) {
    return (nextModel.rent_type == SMConst.RentType.Stay && nextModel.stay_price) ? true : false;
  }

  getErrorFieldName(name) {
    if (this.isBasicPlan()) {
      return name;
    } else {
      return 'plans/'+this.props.planIndex+'/'+name;
    }
  }

  getKey(name) {
    return 'plan-'+this.props.planIndex+'-'+name;
  }

  completeButtonDidSelect(e) {
    this.props.delegate.planEditDidCompleted(e);
  }

  fieldDidChange(e) {
    let name = e.currentTarget.name,
        value = e.currentTarget.value,
        mergeData = {},
        nextModel = {};

    mergeData[name] = e.currentTarget.type === 'checkbox' ? e.currentTarget.checked : value;
    if (e.currentTarget.type === 'checkbox') {
      mergeData[name] = e.currentTarget.checked;
    } else if (e.currentTarget.type === 'radio' && name === 'direct_reservation_accepted') {
      mergeData[name] = value === '1';
    } else {
      mergeData[name] = value;
    }
      
    this.updatePlan(mergeData, name);
  }

  updatePlan (mergeData, name, nextModel) {
    nextModel = update(this.state.model, {$merge: mergeData});
    this.setState({model: nextModel});

    if (this.isBasicPlan()) {
      let payload = {
        plan_name: nextModel.plan_name,
        plan_description: nextModel.plan_description,
        rent_type: nextModel.rent_type,
        price_calc_type: nextModel.price_calc_type,
        is_food_plan: nextModel.is_food_plan,
        direct_reservation_accepted: nextModel.direct_reservation_accepted,
        is_last_minute_discount: nextModel.is_last_minute_discount,
        last_minute_discount_percentage: nextModel.last_minute_discount_percentage,
      };

      if (nextModel.rent_type == SMConst.RentType.DayTime) {
        payload = update(payload, {
          $merge: {
            has_hourly_price: nextModel.has_hourly_price,
            hourly_price: nextModel.hourly_price,
            has_daily_price: nextModel.has_daily_price,
            daily_price: nextModel.daily_price,
            has_min_required_hour: nextModel.has_min_required_hour,
            min_required_hour: nextModel.min_required_hour,
            min_required_hour_unit: nextModel.min_required_hour_unit,
            is_required_food: nextModel.is_required_food,
            option_foods: nextModel.option_foods,
            has_min_required_food_price: nextModel.has_min_required_food_price,
            min_required_food_price: nextModel.min_required_food_price,
            session_price: nextModel.session_price,
            has_session_price: nextModel.has_session_price,
            min_required_session_hour: nextModel.min_required_session_hour,
            min_required_session_hour_unit: nextModel.min_required_session_hour_unit,
            has_interval_hour: nextModel.has_interval_hour,
            interval_hour: nextModel.interval_hour,
          }
        });
      } else {
        payload = update(payload, {
          $merge: {
            stay_price: nextModel.stay_price,
            has_min_stay_days: nextModel.has_min_stay_days,
            min_stay_days: nextModel.min_stay_days,
            has_max_stay_days: nextModel.has_max_stay_days,
            max_stay_days: nextModel.max_stay_days,
            has_extra_stay_checkinout_hour: nextModel.has_extra_stay_checkinout_hour,
            extra_stay_checkin_start_hour: nextModel.extra_stay_checkin_start_hour,
            extra_stay_checkin_end_hour: nextModel.extra_stay_checkin_end_hour,
            extra_stay_checkout_hour: nextModel.extra_stay_checkout_hour,
          }
        });
      }

      $(document).trigger("SMRoomHandleUpdate", [{name: name, payload: payload}]);
    } else {
      $(document).trigger("SMRoomHandleUpdate", [{name: 'plans', payload: {plans: {0: nextModel}}}]);
    }
  }

  textFieldDidEndEditing (e) {
    this.fieldDidChange(e);
  }

  textAreaDidEndEditing (e) {
    this.fieldDidChange(e);
  }

  radioButtonDidChangeValue (e) {
    this.fieldDidChange(e);
  }

  checkBoxDidChangeValue (e) {
    let name = e.currentTarget.name,
        value = e.currentTarget.value,
        mergeData = {};

    if (name == "is_required_food" && value == 1 && this.props.room.option_foods.length == 0) {
      window.alert(I18n.t("dashboard.notice_000006"));
      this.setState(function(previousState, currentProps) {
        previousState.model.is_required_food = 0;
        return {model: previousState.model};
      });
    } else {
      this.fieldDidChange(e);
    }
  }

  selectBoxDidChangeValue (e) {
    this.fieldDidChange(e);
  }

  isRentForDaytime() {
    return this.state.model.rent_type == SMConst.RentType.DayTime;
  }

  isRentForStay() {
    return this.state.model.rent_type == SMConst.RentType.Stay;
  }

  renderFoodOption() {
    if (this.isRentForStay()) return null;

    let foodOptionSettings = [
      <div key={this.getKey("is_required_food")} className="mb10">
        <SMFormCheckBox name="is_required_food" id={this.getKey("is_required_food")} value={1} checked={this.state.model.is_required_food} delegate={this} />
        <label htmlFor={this.getKey("is_required_food")} className="form-checkbox">{I18n.t("dashboard.text_000811")}</label>
        <p className="dashboard-title__supplement ml40"> このプランを選択したお客様は、オプション料金の「飲食」を選択しないと購入できなくなります。 </p>
      </div>,
      <div key={this.getKey("has_min_required_food_price")} className="special-price__box">
        <SMFormCheckBox name="has_min_required_food_price" id={this.getKey("has_min_required_food_price")} value={1} checked={this.state.model.has_min_required_food_price} delegate={this} />
        <label htmlFor={this.getKey('has_min_required_food_price')} className="form-checkbox">{I18n.t("dashboard.text_000812")}</label>
        ¥&nbsp;
        <SMFormTextField
          name="min_required_food_price"
          value={SMFormatHelper.price(this.state.model.min_required_food_price)}
          options={{className: 'form-text w110', disabled: !this.state.model.has_min_required_food_price}}
          delegate={this}
        />
        <p className="dashboard-title__supplement ml40"> このプランを選択したお客様は、オプション料金の「飲食」が必須となり、この金額以下では申し込めなくなります。 </p>
        <SMFormValidationMessage name='min_required_food_price' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('min_required_food_price'), this.state.errors)} />
      </div>
    ];

    let foodPlanSettings = [
      <div key={this.getKey("is_food_plan")} className="mb10 special-price__box">
        <SMFormCheckBox name="is_food_plan" id={this.getKey("is_food_plan")} value={1} checked={this.state.model.is_food_plan} delegate={this} />
        <label htmlFor={this.getKey("is_food_plan")} className="form-checkbox">飲食プランとして設定する</label>
        <p className="dashboard-title__supplement ml40"> 「飲食」オプションではなくプランに飲食メニューが含まれる場合はチェックをして下さい。 </p>
      </div>
    ];

    if (this.props.room.option_foods.length > 0) {
      return foodPlanSettings.concat(foodOptionSettings);
    } else {
      return foodPlanSettings;
    }
  }

  renderLastMinuteDiscount() {
    return (
      <div>
        <SMFormCheckBox name="is_last_minute_discount" id={this.getKey('is_last_minute_discount')} value={true} checked={this.state.model.is_last_minute_discount} delegate={this} />
        <label htmlFor={this.getKey("is_last_minute_discount")} className="form-checkbox">直前割を設定する</label>
        割引率
        <SMFormTextField
          name="last_minute_discount_percentage"
          value={SMFormatHelper.price(this.state.model.last_minute_discount_percentage)}
          options={{className: 'form-text w50 mr5 ml5', placeholder: "10", disabled: !this.state.model.is_last_minute_discount}}
          delegate={this}
        />%
        <p className="dashboard-title__supplement ml30">
          10%以上の割引率を設定してください。利用日から5日前までの予約に適用されます。
        </p>
        <SMFormValidationMessage name='last_minute_discount_percentage' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('last_minute_discount_percentage'), this.state.errors)} />
      </div>
    );
  }

  render() {
    let directReservationAcceptedValue;
    switch (this.state.model.direct_reservation_accepted) {
      case true:
        directReservationAcceptedValue = '1';
        break;
      case false:
        directReservationAcceptedValue = '0';
        break;
      default:
        directReservationAcceptedValue = null;
    }

    return (
      <div className="form-casette maincol-lightbox__form">
        <SMFormFieldTitle title='プランの名称'
          subTitle={this.isBasicPlan() ? '省略可。未入力の場合は「基本プラン」と表示されます。' : ''}
          isRequired={!this.isBasicPlan()} />
        <SMFormTextFieldWithError name={this.isBasicPlan() ? 'plan_name' : 'name'}
          value={this.isBasicPlan() ? this.state.model.plan_name : this.state.model.name}
          errorText={SMFormatHelper.errorText('Room', this.isBasicPlan() ? 'plan_name' : this.getErrorFieldName('name'), this.state.errors)}
          placeholderText="基本プラン"
          options={{className:'w400 mr20'}}
          delegate={this} />

        <SMFormFieldTitle title='利用形態'
          subTitle='利用形態を選択してください。'
          isRequired={true} />
        <div className="form-box">
        <SMFormRadio
          name='rent_type'
          items={[
            { label: '時間・１日レンタル',
              value: SMConst.RentType.DayTime,
              disabled: !SMRoomHelper.isAllowedRentType(this.props.room, SMConst.RentType.DayTime)
            },
            { label: '宿泊',
              value: SMConst.RentType.Stay,
              disabled: !SMRoomHelper.isAllowedRentType(this.props.room, SMConst.RentType.Stay)
            }
          ]}
          selectedValue={this.state.model.rent_type}
          delegate={this}
        />
        <SMFormValidationMessage name='rent_type' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('rent_type'), this.state.errors)} />
        </div>
        <div>
          <h2 className="dashboard-title mb20">
            <span className="icon-form icon-form__required">必須</span>予約の承認方式<br />
            <span className="dashboard-title__supplement">
              予約にホストの承認が必要かどうかを設定してください。<br />
              承認なし（今すぐ予約）に設定するとゲストとのやりとりが簡単になり、予約が入りやすくなります。<a href="https://help.spacemarket.com/hc/ja/articles/115009631447" target="_blank" className="ml5">今すぐ予約とは</a>
            </span>
          </h2>
          <SMFormRadioWithError
            name='direct_reservation_accepted'
            items={[
              { label: '承認なし(今すぐ予約)',
                value: '1'
              },
              { label: '承認あり',
                value: '0'
              }
            ]}
            delegate={this}
            selectedValue={directReservationAcceptedValue}
            errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('direct_reservation_accepted'), this.state.errors)}
          />
        </div>

        <SMFormFieldTitle title='プラン内容の説明'
          subTitle={this.isBasicPlan() ? '省略可' : ''}
          isRequired={!this.isBasicPlan()} />
        <SMFormTextAreaWithError name={this.isBasicPlan() ? 'plan_description' : 'description'}
          value={this.isBasicPlan() ? this.state.model.plan_description : this.state.model.description}
          errorText={SMFormatHelper.errorText('Room', this.isBasicPlan() ? 'plan_description' : this.getErrorFieldName('description'), this.state.errors)}
          placeholderText="Wi-Fi、ホワイトボード完備で会議からイベントまでご利用いただけます。その他必要な備品につきましては予約リクエスト時にお問い合わせください。"
          delegate={this} />

        <SMFormFieldTitle title='価格'
          isRequired={true} />
        <div className="form-box">
          <CSSTransitionGroup transitionName='js-list-fade-animation' transitionEnterTimeout={500} transitionLeaveTimeout={0}>
            {this.isRentForDaytime() ? this.renderPriceAreaForDaytime() : ''}
          </CSSTransitionGroup>
          <CSSTransitionGroup transitionName='js-list-fade-animation' transitionEnterTimeout={500} transitionLeaveTimeout={0}>
            {this.isRentForStay() ? this.renderPriceAreaForStay() : ''}
          </CSSTransitionGroup>

          {this.renderFoodOption()}
          {this.renderLastMinuteDiscount()}
        </div>
        {this.renderIntervalTime()}
        <div className="ta-c mb30">
          <a href="#" className="button button-green maincol-buttonarea__button" onClick={this.completeButtonDidSelect.bind(this)}>完了</a>
        </div>
      </div>
    );
  }

  renderPriceAreaForDaytime() {
    return [

      <div key={5}>
        <input type="radio" value={0} id={this.getKey('price_calc_type_0')} name="price_calc_type" checked={this.state.model.price_calc_type == 0} onChange={this.radioButtonDidChangeValue.bind(this)} />
        <label htmlFor={this.getKey('price_calc_type_0')} className="form-radio">{I18n.t("dashboard.label_000400")}</label>
        <span className="dashboard-title__supplement">
          {I18n.t("dashboard.text_000080")}
        </span>
      </div>,

      <div key={6} className="special-price__box">
        <input type="radio" value={1} id={this.getKey('price_calc_type_1')} name="price_calc_type" checked={this.state.model.price_calc_type == 1} onChange={this.radioButtonDidChangeValue.bind(this)} />
        <label htmlFor={this.getKey('price_calc_type_1')} className="form-radio">{I18n.t("dashboard.label_000401")}</label>
        <span className="dashboard-title__supplement">
          {I18n.t("dashboard.text_000081")}
        </span>
      </div>,

      <div key={0}>
        <input type="radio" value={0} id={this.getKey('has_session_price_0')} name='has_session_price' checked={this.state.model.has_session_price == false} onChange={this.radioButtonDidChangeValue.bind(this)} />
        <label htmlFor={this.getKey('has_session_price_0')} className="form-radio">時間ごと・日ごと価格を使用する</label>
        <span className="dashboard-title__supplement">
          利用時間・日を可変にし、1時間・1日あたりの価格を設定します。
        </span>
      </div>,

      <div key={1} className="special-price__box">
        <input type="radio" value={1} id={this.getKey('has_session_price_1')} name="has_session_price" checked={this.state.model.has_session_price == true} onChange={this.radioButtonDidChangeValue.bind(this)} />
        <label htmlFor={this.getKey('has_session_price_1')} className="form-radio">回ごと価格を使用する</label>
        <span className="dashboard-title__supplement">
          利用時間・日を可変にし、回ごとあたりの価格を設定します。
        </span>
      </div>,

      <div key={2} className="special-price__box" style={{display: this.state.model.has_session_price == true ? 'block' : 'none'}}>
        ¥ <SMFormTextField name="session_price" value={SMFormatHelper.price(this.state.model.session_price)} options={{className:'form-text w110'}} delegate={this} />
        <span className="ml5 mr5">/</span>
        <SMFormTextField name="min_required_session_hour" value={this.state.model.min_required_session_hour} options={{className:'form-text w70 mr5'}} delegate={this} />
        <span className="form-select__inner">
          <label className="form-select">
            <SMFormSelectBox name="min_required_session_hour_unit" items={SMFormHelper.hourUnitOptionsForSelect()} selectedValue={this.state.model.min_required_session_hour_unit} delegate={this} />
          </label>
        </span>
        <SMFormValidationMessage name='session_price' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('session_price'), this.state.errors)} />
        <SMFormValidationMessage name='min_required_session_hour' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('min_required_session_hour'), this.state.errors)} />
      </div>,

      <div key={3} className="special-price__box" style={{display: this.state.model.has_session_price == true ? 'none' : 'block'}}>
        <SMFormCheckBox name="has_hourly_price" id={this.getKey("has_hourly_price")} value={1} checked={this.state.model.has_hourly_price} delegate={this} />
        <label htmlFor={this.getKey("has_hourly_price")} className="form-checkbox">時間価格を有効にする</label>
        <span className="mr50">¥&nbsp;
          <SMFormTextField
            name="hourly_price"
            value={SMFormatHelper.price(this.state.model.hourly_price)}
            options={{className: 'form-text w110', disabled: !this.state.model.has_hourly_price}}
            delegate={this}
          /> /時間
        </span>
        <SMFormCheckBox name="has_daily_price" id={this.getKey("has_daily_price")} value={1} checked={this.state.model.has_daily_price} delegate={this} />
        <label htmlFor={this.getKey("has_daily_price")} className="form-checkbox">終日価格を有効にする</label>
        ¥&nbsp;
        <SMFormTextField
          name="daily_price"
          value={SMFormatHelper.price(this.state.model.daily_price)}
          options={{className: 'form-text w110', disabled: !this.state.model.has_daily_price}}
          delegate={this}
        /> /日
        <SMFormValidationMessage name='hourly_price' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('hourly_price'), this.state.errors)} />
        <SMFormValidationMessage name='daily_price' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('daily_price'), this.state.errors)} />
        <SMFormValidationMessage name='has_hourly_price' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('has_hourly_price'), this.state.errors)} />
        <SMFormValidationMessage name='has_daily_price' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('has_daily_price'), this.state.errors)} />
      </div>,

      <div key={4} className="special-price__box">
        <SMFormCheckBox name="has_min_required_hour" id={this.getKey("has_min_required_hour")} value={1} checked={this.state.model.has_min_required_hour} delegate={this} />
        <label htmlFor={this.getKey("has_min_required_hour")} className="form-checkbox">最低利用時間を設定する</label>
        <SMFormTextField
          name="min_required_hour"
          value={this.state.model.min_required_hour}
          options={{className: 'form-text w70 mr5', disabled: !this.state.model.has_min_required_hour}}
          delegate={this}
        />
        <span className="form-select__inner">
          <label className="form-select">
            <SMFormSelectBox
              name="min_required_hour_unit"
              items={SMFormHelper.hourUnitOptionsForSelect()}
              selectedValue={this.state.model.min_required_hour_unit}
              options={{disabled: !this.state.model.has_min_required_hour}}
              delegate={this}
            />
          </label>
        </span>
        <SMFormValidationMessage name='min_required_hour' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('min_required_hour'), this.state.errors)} />
      </div>
    ];
  }

  renderPriceAreaForStay() {
    return [
      <div key={5}>
        <input type="radio" value={0} id={this.getKey('price_calc_type_0')} name="price_calc_type" checked={this.state.model.price_calc_type == 0} onChange={this.radioButtonDidChangeValue.bind(this)} />
        <label htmlFor={this.getKey('price_calc_type_0')} className="form-radio">{I18n.t("dashboard.label_000400")}</label>
        <span className="dashboard-title__supplement">
          {I18n.t("dashboard.text_000080")}
        </span>
      </div>,

      <div key={6} className="special-price__box">
        <input type="radio" value={1} id={this.getKey('price_calc_type_1')} name="price_calc_type" checked={this.state.model.price_calc_type == 1} onChange={this.radioButtonDidChangeValue.bind(this)} />
        <label htmlFor={this.getKey('price_calc_type_1')} className="form-radio">{I18n.t("dashboard.label_000401")}</label>
        <span className="dashboard-title__supplement">
          {I18n.t("dashboard.text_000081")}
        </span>
      </div>,

      <div key='stayprice-1' className="special-price__box">
        ¥&nbsp;
        <SMFormTextField name='stay_price'
          value={SMFormatHelper.price(this.state.model.stay_price)}
          options={{className:'form-text w110'}}
          delegate={this} /> /{this.state.model.price_calc_type_text}
        <SMFormValidationMessage name='stay_price' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('stay_price'), this.state.errors)} />
      </div>,

      <div key='stayprice-2' className="special-price__box">
        <input type="hidden" value="0" name="has_min_stay_days" />
        <SMFormCheckBox name="has_min_stay_days" id={this.getKey("has_min_stay_days")} value={1} checked={this.state.model.has_min_stay_days} delegate={this} />
        <label htmlFor={this.getKey("has_min_stay_days")} className="form-checkbox">最低泊数を設定する</label>
        <span className="mr50"><SMFormTextField name="min_stay_days"
          value={this.state.model.min_stay_days}
          options={{className: 'form-text w70', disabled: !this.state.model.has_min_stay_days}}
          delegate={this} /> 泊</span>
        <input type="hidden" value="0" name="has_max_stay_days" />
        <SMFormCheckBox name="has_max_stay_days" id={this.getKey("has_max_stay_days")} value={1} checked={this.state.model.has_max_stay_days} delegate={this} />
        <label htmlFor={this.getKey("has_max_stay_days")} className="form-checkbox">最高泊数を設定する</label>
        <SMFormTextField name="max_stay_days"
          value={this.state.model.max_stay_days}
          options={{className: 'form-text w70', disabled: !this.state.model.has_max_stay_days}}
          delegate={this} /> 泊
        <SMFormValidationMessage name='min_stay_days' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('min_stay_days'), this.state.errors)} />
        <SMFormValidationMessage name='max_stay_days' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('max_stay_days'), this.state.errors)} />
      </div>,

      <div key='stayprice-3' className="special-price__box">
        <input type="hidden" value="0" name="has_extra_stay_checkinout_hour" />
        <SMFormCheckBox name="has_extra_stay_checkinout_hour" id={this.getKey("has_extra_stay_checkinout_hour")} value={1} checked={this.state.model.has_extra_stay_checkinout_hour} delegate={this} />
        <label htmlFor={this.getKey("has_extra_stay_checkinout_hour")} className="form-checkbox">チェックイン/アウト時間を変更する</label>
        チェックイン&nbsp;
        <SMFormTextField name="extra_stay_checkin_start_hour"
          value={SMFormatHelper.price(this.state.model.extra_stay_checkin_start_hour)}
          options={{className: 'form-text w40', disabled: !this.state.model.has_extra_stay_checkinout_hour}}
          placeholderText='15'
          delegate={this} />
        &nbsp;:00〜
        <SMFormTextField name="extra_stay_checkin_end_hour"
          value={SMFormatHelper.price(this.state.model.extra_stay_checkin_end_hour)}
          options={{className: 'form-text w40', disabled: !this.state.model.has_extra_stay_checkinout_hour}}
          placeholderText='23'
          delegate={this} />&nbsp;:00
        <span className='ml20'>
          チェックアウト&nbsp;
          <SMFormTextField name="extra_stay_checkout_hour"
            value={SMFormatHelper.price(this.state.model.extra_stay_checkout_hour)}
            options={{className: 'form-text w40', disabled: !this.state.model.has_extra_stay_checkinout_hour}}
            placeholderText='10'
            delegate={this} />&nbsp;:00
        </span>
        <SMFormValidationMessage name='extra_stay_checkin_start_hour' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('extra_stay_checkin_start_hour'), this.state.errors)} />
        <SMFormValidationMessage name='extra_stay_checkin_end_hour' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('extra_stay_checkin_end_hour'), this.state.errors)} />
        <SMFormValidationMessage name='extra_stay_checkout_hour' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('extra_stay_checkout_hour'), this.state.errors)} />
      </div>
    ];
  }

  renderIntervalTime () {
    const display = this.state.model.has_hourly_price || (this.state.model.has_session_price && this.state.model.min_required_session_hour_unit == 0 );

    return (
      <div style={{display: display ? 'block' : 'none'}}>
        <SMFormFieldTitle
          title='片付け時間'
          subTitle={'時間単位で貸し出す場合に予約終了後片付け時間を設け、すぐに別の予約が入らないようにできます。'}
          isRequired={false}
        />
        <div key="interval-hour" className="form-box">
          <SMFormCheckBox
            name="has_interval_hour"
            id={this.getKey("has_interval_hour")}
            value="片付け時間を設ける"
            checked={this.state.model.has_interval_hour}
            delegate={this}
          />
          <label htmlFor={this.getKey("has_interval_hour")} className="form-checkbox">片付け時間を設ける</label>
          予約終了後 <SMFormTextField
              name="interval_hour"
              value={this.state.model.interval_hour}
              options={{className: 'form-text w50', disabled: !this.state.model.has_interval_hour}}
              delegate={this}
            /> 時間は次の予約を受け付けない
          <SMFormValidationMessage name='interval_hour' errorText={SMFormatHelper.errorText('Room', this.getErrorFieldName('interval_hour'), this.state.errors)} />
        </div>
      </div>
    );
  }
}

SMOPlanEditView.propTypes = {
  model: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  delegate: PropTypes.object.isRequired,
  errors: PropTypes.array,
  planIndex: PropTypes.number,
};
SMOPlanEditView.defaultProps = {
  errors: [],
  planIndex: -1,
};
export default SMOPlanEditView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMOPlanEditView.jsx